import React, { Fragment, useEffect, useState } from "react";
import SwiperSlider from "../SwiperSlide/SwiperSlider"; //슬라이더
import Axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Main = () => {
  const { t } = useTranslation();
  const [newsData, setNewsData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [publicationsData, setPublicationsData] = useState([]);
  const [option, setOption] = useState(1);
  const navigate = useNavigate();

  const moveDetail1 = (idx) => {
    navigate(`/news/detail/${idx}`);
    window.location.reload();
  };

  const moveDetail2 = (idx) => {
    navigate(`/project/detail/${idx}`);
    window.location.reload();
  };

  const moveDetail3 = (idx) => {
    navigate(`/publications/detail/${idx}`);
    window.location.reload();
  };

  useEffect(() => {
    // 초기에 뉴스 데이터를 가져옵니다.
    Axios.get("http://micronpharm.com/api/get/news_list")
      .then((res) => {
        setNewsData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const moveDown = () => {
    let location = document.querySelector(".main_second_area").offsetTop;
    window.scrollTo({ top: location, behavior: "smooth" });
  };
  //메인페이지 게시판 3개 미리보기 출력
  const changeOption = (num) => {
    setOption(num);
    if (num === 1) {
      Axios.get("http://micronpharm.com/api/get/news_list")
        .then((res) => {
          setNewsData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (num === 2) {
      Axios.get("http://micronpharm.com/api/get/project_list")
        .then((res) => {
          setProjectData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (num === 3) {
      Axios.get("http://micronpharm.com/api/get/publications_list")
        .then((res) => {
          setPublicationsData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const moveBoardList = () => {
    switch (option) {
      case 1:
        navigate("/news");
        break;
      case 2:
        navigate("/project");
        break;
      case 3:
        navigate("/publications");
        break;
      default:
        break;
    }
    window.location.reload();
  };

  const handleMain01 = () => {
    navigate("/about");
    window.location.reload();
  };

  const moveContact = () => {
    navigate("/contact");
    window.location.reload();
  };

  return (
    <div>
      <div className="main_area">
        <div className="main_first_area">
          <div className="main_banner_box">
            <div className="main_banner">
              <SwiperSlider />
            </div>
            <div className="scroll_btn_box">
              <div
                className="scroll_btn animate__animated animate__bounce animate__infinite"
                onClick={moveDown}
              ></div>
            </div>
          </div>
        </div>
        <div className="main_second_area">
          {/*<div className="second_banner_box">
            <div className="middle_content">
              <div className="middle_text">WHAT IS MICRONEEDLE?</div>
              <div className="middle_btn_box">
                <div className="middle_btn">READ MORE {">"}</div>
              </div>
            </div>
          </div> */}
          <div className="second_content_back">
            <div className="second_content">
              <div className="snd_title">{t("main.main01")}</div>
              {/*<div className="snd_text">
                Microneedle is a joint effort of cutting-edge technologies.
                <br />
                QuadMedicine’s multidisciplinary team specializes in technology
                integration for
                <br />
                medical and pharmaceutical microneedle development.
              </div> */}
              <div className="snd_content_box">
                <div className="content_box">
                  <div className="content_img_1"></div>
                  <div className="content_title">{t("main.main01-1")}</div>
                </div>
                <div className="content_box">
                  <div className="content_img_2"></div>
                  <div className="content_title">{t("main.main01-2")}</div>
                </div>
                <div className="content_box last_box">
                  <div className="content_img_3"></div>
                  <div className="content_title">{t("main.main01-3")}</div>
                </div>
              </div>
              <div className="snd_btn_box">
                <div className="snd_btn">
                  <div onClick={handleMain01}>SEE MORE {">"}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main_third_area">
          <div className="third_banner_box">
            <div className="banner_inner_box">
              <div className="banner_title">{t("main.main02")}</div>
              <div className="video_box">
                <video width="100%" height="100%" controls loop autoPlay muted>
                  <source src="video/main.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="banner_text">{t("main.main02-1")}</div>
              {/* <div className="banner_btn_box">
                <div className="banner_btn">SEE MORE {">"}</div>
              </div> */}
            </div>
          </div>
          <div className="third_content_box">
            <div className="trd_content_box">
              <div className="trd_tab_box">
                <div
                  className={`trd_tab ${option === 1 && "active"}`}
                  onClick={() => changeOption(1)}
                >
                  NEWS
                </div>
                <div
                  className={`trd_tab ${option === 2 && "active"}`}
                  onClick={() => changeOption(2)}
                >
                  PROJECT
                </div>
                <div
                  className={`trd_tab ${option === 3 && "active"}`}
                  onClick={() => changeOption(3)}
                >
                  PUBLICATIONS
                </div>
              </div>
              <div className="trd_table_box">
                <div className="table_header_box">
                  <div className="header_text">NO.</div>
                  <div className="header_text long_text">Title</div>
                  <div className="header_text">View</div>
                  <div className="header_text mid_text">Date</div>
                </div>

                <div className="table_body_box">
                  {option === 1 &&
                    newsData.map((item, idx) => (
                      <div key={idx} className="news_item">
                        <div className="body_text">{idx + 1}</div>
                        <div
                          className="body_text long_text"
                          key={idx}
                          onClick={() => moveDetail1(item.idx)}
                        >
                          {item.title}
                        </div>
                        <div className="body_text">{item.hit}</div>
                        <div className="body_text mid_text">
                          {item.formatDate}
                        </div>
                      </div>
                    ))}
                  {option === 2 &&
                    projectData.map((item, idx) => (
                      <div key={idx} className="news_item">
                        <div className="body_text">{idx + 1}</div>
                        <div
                          className="body_text long_text"
                          key={idx}
                          onClick={() => moveDetail2(item.idx)}
                        >
                          {item.title}
                        </div>
                        <div className="body_text">{item.hit}</div>
                        <div className="body_text mid_text">
                          {item.formatDate}
                        </div>
                      </div>
                    ))}
                  {option === 3 &&
                    publicationsData.map((item, idx) => (
                      <div key={idx} className="news_item">
                        <div className="body_text">{idx + 1}</div>
                        <div
                          className="body_text long_text"
                          key={idx}
                          onClick={() => moveDetail3(item.idx)}
                        >
                          {item.title}
                        </div>
                        <div className="body_text">{item.hit}</div>
                        <div className="body_text mid_text">
                          {item.formatDate}
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              <div className="table_btn_box">
                <div className="table_btn" onClick={() => moveBoardList()}>
                  SEE MORE {">"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main_fourth_area">
          <div className="fth_banner_box">
            <div className="fth_banner_inner_box">
              <div className="fth_banner_title">{t("main.main03")}</div>
              <div className="fth_banner_text">{t("main.main03-1")}</div>
              <div className="fth_btn_box">
                <div className="fth_btn" onClick={() => moveContact()}>
                  Contact Us {">"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
